export const CATALOG_PAGE_SIZE = 25

const BOTTOM_TOLERANCE_PX = 80

/**
 * Indica si conviene cargar el siguiente batch: el usuario llegó al final
 * del contenido visible o el listado aún no llena la pantalla (no hay scroll).
 */
export function shouldTriggerCatalogLoadMore(scrollThresholdPercent = 75) {
  const scrollY = window.scrollY
  const windowHeight = window.innerHeight
  const pageHeight = document.documentElement.scrollHeight

  if (pageHeight <= windowHeight + BOTTOM_TOLERANCE_PX) {
    return true
  }

  const distanceFromBottom = pageHeight - (scrollY + windowHeight)
  if (distanceFromBottom <= BOTTOM_TOLERANCE_PX) {
    return true
  }

  const scrollable = pageHeight - windowHeight
  if (scrollable > 0) {
    const scrollPercentage = (scrollY / scrollable) * 100
    if (scrollPercentage >= scrollThresholdPercent) {
      return true
    }
  }

  return false
}

export function isFullCatalogBatch(batchCount) {
  return batchCount >= CATALOG_PAGE_SIZE
}
